var imageModule = angular.module('evtviewer.imageViewer');